import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processWorkType = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_WORK_TYPE, item)
}

export const fetchWorkTypes = (store) => {
    return axios.get(`/api/work-types`)
        .then(res => {
            _.each(res.data.data, item => processWorkType(store, item))
            return res
        })
}

export const createWorkType = (store, item) => {
    return axios.post(`/api/work-types`, item)
        .then(res => {
            processWorkType(store, res.data.data)
            return res
        })
}

export const updateWorkType = (store, item) => {
    return axios.patch(`/api/work-types/${item.id}`, item)
        .then(res => {
            processWorkType(store, res.data.data)
            return res
        })
}

export const createOrUpdateWorkType = (store, item) => {
    return item.id ?
        updateWorkType(store, item) :
        createWorkType(store, item)
}

export const removeWorkType = (store, item) => {
    return axios.delete(`/api/work-types/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_WORK_TYPE, item)
            return res
        })
}